import * as React from 'react'
import { SVGProps } from 'react'

const SUSHIUSD = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width='33' height='32' viewBox='0 0 33 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='16.0059' cy='15.9996' r='15.9996' fill='white' />
    <path
      d='M9.67711 7.73303L26.1387 18.8479L22.0676 24.7992L5.60596 13.5968L9.67711 7.73303Z'
      fill='url(#paint0_linear_4956_76338)'
    />
    <path
      d='M26.3176 18.8705C24.9105 20.9245 20.1617 20.1208 15.6767 16.9058C11.1037 13.7801 8.64138 9.58271 9.9605 7.52868C11.3676 5.47465 16.1164 6.2784 20.6014 9.49341C25.1744 12.5298 27.6367 16.8165 26.3176 18.8705Z'
      fill='url(#paint1_linear_4956_76338)'
    />
    <path
      d='M22.0493 24.7443C20.6378 26.7849 15.8737 25.9864 11.3743 22.7924C6.87493 19.5984 4.31646 15.5171 5.72803 13.3878C7.1396 11.3471 11.9037 12.1456 16.403 15.3397C20.9024 18.5337 23.3727 22.7037 22.0493 24.7443Z'
      fill='url(#paint2_linear_4956_76338)'
    />
    <path
      d='M26.0736 18.7778L22.0002 24.7738C20.5834 26.8019 15.8017 25.9201 11.2856 22.8339C10.4001 22.2167 9.60311 21.5995 8.80615 20.894C9.42601 20.8059 10.223 20.4532 11.0199 19.5714C12.4367 18.0724 13.1452 17.7197 13.765 17.8079C14.3849 17.8079 15.0933 18.4251 16.2444 19.9241C17.3956 21.4231 18.9895 21.864 19.9636 21.0704C20.0521 20.9822 20.1407 20.9822 20.2292 20.894C21.0262 20.2768 21.2918 20.0123 22.7972 17.1906C23.1514 16.4852 24.3911 15.3389 26.0736 15.868C26.5163 17.0143 26.5163 17.9842 26.0736 18.7778Z'
      fill='#0E0F23'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M25.3252 18.5563C24.0932 20.327 19.7815 19.4416 15.6458 16.52C11.4221 13.5985 8.95822 9.88009 10.1901 8.10944C11.4221 6.33879 15.7338 7.22411 19.8695 10.1457C24.0053 13.0673 26.4691 16.7856 25.3252 18.5563ZM21.4539 15.9003C20.8379 16.7856 18.7261 16.343 16.6142 14.9264C14.5903 13.5099 13.3584 11.6507 13.9744 10.7654C14.5903 9.88007 16.7022 10.3227 18.8141 11.7393C20.8379 13.1558 22.0698 15.015 21.4539 15.9003Z'
      fill='white'
    />
    <path
      d='M9.30957 9.43749C9.30957 9.36361 9.22957 9.28973 9.14957 9.36361C9.06958 9.43749 8.98958 9.43749 8.98958 9.51136C9.06958 9.733 9.14957 9.88075 9.14957 10.0285C9.14957 10.1024 9.22957 10.1763 9.30957 10.1024C9.38957 10.1024 9.46957 10.0285 9.38957 9.95463C9.38957 9.80687 9.38957 9.65912 9.30957 9.43749Z'
      fill='white'
    />
    <path
      d='M9.86691 10.7923C9.86691 10.7033 9.77992 10.6142 9.69294 10.7033C9.60596 10.7923 9.60596 10.7923 9.60596 10.8814C10.5628 13.1077 12.5634 15.5122 15.1729 17.2933C15.2598 17.3823 15.3468 17.2933 15.4338 17.2933C15.5208 17.2042 15.4338 17.1152 15.4338 17.0261C12.7373 15.245 10.8237 12.9296 9.86691 10.7923Z'
      fill='white'
    />
    <path
      d='M20.4356 19.6261C20.3535 19.6261 20.2715 19.6261 20.2715 19.7061C20.2715 19.7861 20.2715 19.8661 20.3535 19.8661C20.5997 19.9461 20.9279 20.026 21.174 20.106C21.2561 20.106 21.3381 20.106 21.3381 20.026C21.3381 19.9461 21.3381 19.8661 21.2561 19.8661C21.0099 19.7861 20.6817 19.7061 20.4356 19.6261Z'
      fill='white'
    />
    <path
      d='M22.0445 19.9161C21.9588 19.9161 21.873 19.9961 21.873 20.0761C21.873 20.1561 21.9588 20.2361 22.0445 20.2361C22.7302 20.3161 23.5016 20.3961 24.1016 20.3161C24.1873 20.3161 24.273 20.2361 24.273 20.1561C24.273 20.0761 24.1873 19.9961 24.1016 19.9961C23.4159 20.0761 22.7302 19.9961 22.0445 19.9161Z'
      fill='white'
    />
    <defs>
      <linearGradient
        id='paint0_linear_4956_76338'
        x1='6.23383'
        y1='7.50939'
        x2='8.52922'
        y2='18.7919'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#03B8FF' />
        <stop offset='1' stopColor='#FA52A0' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_4956_76338'
        x1='8.73902'
        y1='6.41849'
        x2='10.8369'
        y2='17.9389'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#03B8FF' />
        <stop offset='1' stopColor='#FA52A0' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_4956_76338'
        x1='3.19029'
        y1='8.00897'
        x2='5.29564'
        y2='19.4582'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#03B8FF' />
        <stop offset='1' stopColor='#FA52A0' />
      </linearGradient>
    </defs>
  </svg>
)

export default SUSHIUSD
